import * as React from 'react';

import cn from 'classnames';

import { ISplitTextProps } from './types';

import * as s from './SplitText.scss';

export const SplitText: React.FC<ISplitTextProps> = (props) => {
	const { text, wordClassName } = props;

	return (
		<React.Fragment>
			{text.trim()
				.split(/\s+/)
				.map((word) => (
					<React.Fragment key={word}>
						<div className={cn(s.word, wordClassName)}>{word}</div>
						{' '}
					</React.Fragment>
				))}
		</React.Fragment>
	);
};
